module.exports = __webpack_public_path__ + "static/media/make-series.e69b122e.jpg";